import { ProfileValueOption, ProfileFields } from '@backrs_ui/grow-ui/src/redux/profile/profile';

import { ResolverFunction } from './resolvers.config';
import { FieldConfig, ProfilePageConfig } from '../types/profile.types';
import { createFieldConfig } from '../utils/fields.helpers';
import { mapStandardProfileArrayValues } from '../utils/resolvers.helpers';

export const RELATIONSHIPS_FIELD_CONFIGS: Partial<FieldConfig> = {
  resourcesLanguages: createFieldConfig({
    key: 'resourcesLanguages',
    type: { variant: 'API_AUTOCOMPLETE', autoCompleteEndpoint: '/profile/lookups/languages' },
    showSearch: true,
    placeholder: 'Search Languages',
  }),
  demographicsFamilyRoles: createFieldConfig({
    key: 'demographicsFamilyRoles',
    type: { variant: 'MULTIPLE_SELECT' },
    chipType: 'pill',
    placeholder: 'Select Family Roles',
  }),
  demographicsChildhoodExperiences: createFieldConfig({
    key: 'demographicsChildhoodExperiences',
    type: { variant: 'MULTIPLE_SELECT' },
    chipType: 'pill',
    placeholder: 'Select Childhood',
  }),
  demographicsRelationshipExperiences: createFieldConfig({
    key: 'demographicsRelationshipExperiences',
    type: { variant: 'CHECKBOX_GROUP' },
  }),
};

export const RELATIONSHIPS_PAGE_CONFIG: ProfilePageConfig = {
  title: 'Relationships',
  description: 'Share the networks and connections that you have formed.',
  sections: [
    {
      title: 'Languages',
      keys: ['resourcesLanguages'],
    },
    {
      title: 'Family Role',
      keys: ['demographicsFamilyRoles'],
    },
    {
      title: 'Childhood',
      keys: ['demographicsChildhoodExperiences'],
    },
    {
      title: 'Relationship Experiences',
      keys: ['demographicsRelationshipExperiences'],
      description: 'Select all that apply to you.',
    },
  ],
};

export const RELATIONSHIPS_HELPERS: Partial<
  Record<ProfileFields, ResolverFunction<string | number | ProfileValueOption>>
> = {
  resourcesLanguages: (profile, options) =>
    (profile.profile.resourcesLanguages ?? [])
      .map((language) => {
        if (typeof language === 'string') return language;

        return (
          options.resourcesLanguages?.find((opt) => opt.id === language.id)?.language ??
          language.language
        );
      })
      .filter(Boolean),

  demographicsFamilyRoles: (profile, options) =>
    mapStandardProfileArrayValues(
      profile.profile.demographicsFamilyRoles,
      options.demographicsFamilyRoles,
    ),

  demographicsChildhoodExperiences: (profile, options) =>
    mapStandardProfileArrayValues(
      profile.profile.demographicsChildhoodExperiences,
      options.demographicsChildhoodExperiences,
    ),

  demographicsRelationshipExperiences: (profile, options) =>
    mapStandardProfileArrayValues(
      profile.profile.demographicsRelationshipExperiences,
      options.demographicsRelationshipExperiences,
    ),
};
